// 组件对象，大写
import proportion from './proportion.vue'
export default proportion
